export const parseParticipants = (participantsRaw?: string): string[] => {
  if (!participantsRaw) return [];
  try {
    const parsed = JSON.parse(participantsRaw);
    if (Array.isArray(parsed)) {
      return parsed.map((p) => (p == null ? '' : String(p).trim())).filter(Boolean);
    }
  } catch {
    // best-effort parsing continues below
  }
  return participantsRaw
    .split(/[\n,]+/)
    .map((p) => p.trim())
    .filter(Boolean);
};

// Osoby powiązane z wizytą planowaną: planujący + uczestnicy (bez duplikatów)
export const getPlannedVisitPeople = (visit: { createdBy?: string; participants?: string }): string[] => {
  const people = [visit.createdBy, ...parseParticipants(visit.participants)]
    .filter((p): p is string => Boolean(p));
  return Array.from(new Set(people));
};

// Stan wizyty planowanej w kalendarzu: przyszła / odbyta z raportem / odbyta bez raportu.
// Porównanie po samej dacie (bez godziny i strefy); wizyta wielodniowa liczy się do ostatniego dnia.
export type PlannedVisitStatus = "future" | "done" | "missing";

const datePart = (iso: string) => iso.slice(0, 10);
const todayPart = (d: Date) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const plannedVisitStatus = (
  visit: { dateStart: string; dateEnd?: string | null; reportId?: string | null },
  today: Date = new Date()
): PlannedVisitStatus => {
  const lastDay = datePart(visit.dateEnd || visit.dateStart);
  if (lastDay >= todayPart(today)) return "future";
  return visit.reportId ? "done" : "missing";
};

export const PLANNED_VISIT_STYLE: Record<PlannedVisitStatus, { back: string; border: string; font: string; label: string; tag: string }> = {
  future: { back: "#e2e8f0", border: "#64748b", font: "#1e293b", label: "Planowana", tag: "Planowana" },
  done: { back: "#DCFCE7", border: "#16A34A", font: "#14532D", label: "Odbyta, raport utworzony", tag: "Z raportem" },
  missing: { back: "#FEE2E2", border: "#DC2626", font: "#7F1D1D", label: "Odbyta, brak raportu", tag: "Brak raportu" },
};
